import React from 'react';
import { useLocation } from "react-router-dom";
import ModalBasic from './ModalBasic';

function HotkeysModal({ modalOpen, setModalOpen, user }) {
  const { pathname } = useLocation();

  // Define all available hotkeys based on user permissions
  const getHotkeys = () => {
    const baseHotkeys = [
      {
        category: "General",
        hotkeys: [
          { key: "Ctrl + I", description: "Open impersonation modal", condition: user?.type === "saucey_admin" },
          { key: "Ctrl + C + M", description: "Copy merchant EasyID + Name", condition: user?.type === "saucey_admin" },
          { key: "Ctrl + C + S", description: "Copy store ID + Name", condition: user?.type === "saucey_admin" },
          { key: "Ctrl + Shift + G", description: "Go to store website (Direct only)", condition: true },
        ]
      },
    //   {
    //     category: "Store Management",
    //     hotkeys: [
    //       { key: "Ctrl + S", description: "Go to store settings", condition: true },
    //       { key: "Ctrl + U", description: "Go to store users", condition: true },
    //       { key: "Ctrl + P", description: "Go to store payment", condition: true },
    //       { key: "Ctrl + I", description: "Go to store feed", condition: true },
    //     ]
    //   },
    //   {
    //     category: "Store Table (when context menu is open)",
    //     hotkeys: [
    //       { key: "I", description: "Impersonate store", condition: user?.type === "saucey_admin" },
    //       { key: "E", description: "Edit store", condition: user?.type === "saucey_admin" },
    //       { key: "C", description: "Copy store EasyID + Name", condition: user?.type === "saucey_admin" },
    //       { key: "Shift + C", description: "Copy store ID", condition: user?.type === "saucey_admin" },
    //       { key: "G", description: "Go to store website", condition: user?.type === "saucey_admin" },
    //       { key: "A", description: "Archive store", condition: user?.type === "saucey_admin" },
    //     ]
    //   },
    //   {
    //     category: "Merchant Table (when context menu is open)",
    //     hotkeys: [
    //       { key: "Ctrl + E", description: "Edit merchant", condition: user?.type === "saucey_admin" },
    //       { key: "Ctrl + C", description: "Copy merchant EasyID + Name", condition: user?.type === "saucey_admin" },
    //       { key: "Shift + Ctrl + C", description: "Copy merchant ID", condition: user?.type === "saucey_admin" },
    //       { key: "Ctrl + A", description: "Archive merchant", condition: user?.type === "saucey_admin" },
    //       { key: "Ctrl + G", description: "Go to merchant mothership", condition: user?.type === "saucey_admin" },
    //     ]
    //   }
    ];

    if (pathname.startsWith("/admin/review-custom-products")) {
      baseHotkeys.push({
        category: "Custom product review (modal open)",
        hotkeys: [
          {
            key: "Ctrl + A",
            description: "Approve & publish selected custom product (or Cmd + A on Mac)",
            condition: true,
          },
          {
            key: "Ctrl + D",
            description: "Decline selected custom product (or Cmd + D on Mac)",
            condition: true,
          },
        ],
      });
    }

    // Filter out hotkeys that don't meet conditions
    return baseHotkeys.map(category => ({
      ...category,
      hotkeys: category.hotkeys.filter(hotkey => hotkey.condition !== false)
    })).filter(category => category.hotkeys.length > 0);
  };

  const hotkeyCategories = getHotkeys();

  return (
    <ModalBasic
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      title="Keyboard Shortcuts"
      width="2xl"
    >
      <div className="space-y-6">
        {hotkeyCategories.map((category, categoryIndex) => (
          <div key={categoryIndex}>
            <h3 className="text-lg font-semibold text-slate-800 dark:text-slate-200 mb-3">
              {category.category}
            </h3>
            <div className="space-y-2">
              {category.hotkeys.map((hotkey, hotkeyIndex) => (
                <div key={hotkeyIndex} className="flex items-center justify-between py-2 px-3 bg-slate-50 dark:bg-slate-800 rounded-lg">
                  <span className="text-slate-600 dark:text-slate-300">
                    {hotkey.description}
                  </span>
                  <div className="flex items-center space-x-1">
                    {hotkey.key.split(' + ').map((key, keyIndex) => (
                      <React.Fragment key={keyIndex}>
                        <kbd className="px-2 py-1 text-xs font-semibold text-slate-800 dark:text-slate-200 bg-slate-200 dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded shadow-sm">
                          {key}
                        </kbd>
                        {keyIndex < hotkey.key.split(' + ').length - 1 && (
                          <span className="text-slate-400">+</span>
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
        
        {hotkeyCategories.length === 0 && (
          <div className="text-center py-8 text-slate-500 dark:text-slate-400">
            No keyboard shortcuts available for your current permissions.
          </div>
        )}
        
        <div className="pt-4 border-t border-slate-200 dark:border-slate-700">
          <p className="text-sm text-slate-500 dark:text-slate-400 text-center">
            Hold <kbd className="px-1 py-0.5 text-xs font-semibold text-slate-800 dark:text-slate-200 bg-slate-200 dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded">Ctrl</kbd> to show this modal
          </p>
        </div>
      </div>
    </ModalBasic>
  );
}

export default HotkeysModal;
